const RefreshLimit = (() => {
    /**
     * 本地存储工具 - 设置
     */
    function setStorage(key, value) {
        localStorage.setItem(key, String(value))
    }

    /**
     * 本地存储工具 - 获取
     */
    function getStorage(key) {
        return localStorage.getItem(key)
    }

    /**
     * 清除本地存储指定key
     */
    function removeStorage(key) {
        localStorage.removeItem(key)
    }

    // 核心刷新检测逻辑
    function checkRefresh() {
        // 关键：上次是强制关闭页面，则直接重置计数并清除关闭标记
        const isForceClose = getStorage('force_close') === '1'
        if (isForceClose) {
            setStorage('refresh_cnt', 0)
            removeStorage('force_close')
        }

        const refreshCntStr = getStorage('refresh_cnt')
        let refreshCnt = Number(refreshCntStr) || 0

        const lastTimeStr = getStorage('refresh_time') || '1999-01-01 00:00:00'
        const lastTime = new Date(lastTimeStr)
        const now = new Date()
        const diffTime = now.getTime() - lastTime.getTime()

        // 打印当前刷新次数
        console.log('当前累计快速刷新次数：', refreshCnt)

        // 5秒内快速刷新，计数+1
        if (diffTime < 5000) {
            refreshCnt += 1
            setStorage('refresh_cnt', refreshCnt)
        }

        // 分级拦截逻辑
        if (refreshCnt > 5) {
            location.href = 'https://www.baidu.com'
        } else if (refreshCnt > 4) {
            // 标记本次是代码强制关闭页面
            setStorage('force_close', '1')
            window.close()
        } else if (refreshCnt > 3) {
            alert('刷新次数过多，请勿多次连续刷新！')
        }

        // 更新本次刷新时间到本地存储
        setStorage('refresh_time', now.toLocaleString())

        // 间隔超过10秒重置计数为1
        if (diffTime > 10000) {
            setStorage('refresh_cnt', 1)
        }
    }

    // 页面卸载监听
    function listenUnload() {
        window.addEventListener('unload', () => {
            // messager_send_current_info("close");
        })
    }

    return {
        init() {
            checkRefresh()
            listenUnload()
        },
        resetCount() {
            setStorage('refresh_cnt', 0)
            removeStorage('force_close')
        }
    }
})()

export default RefreshLimit